import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MapPin } from "lucide-react";

/**
 * Horizontal-bar heatmap of the top districts by network count.
 * Uses the /admin/heatmap endpoint.
 */
export default function DistrictHeatmap() {
  const [data, setData] = useState(null);
  const [chamber, setChamber] = useState("House");

  useEffect(() => { api.get("/admin/heatmap").then(r => setData(r.data)).catch(() => {}); }, []);

  if (!data) return null;
  const rows = (chamber === "House" ? data.house_districts : data.senate_districts).slice(0, 10);
  const max = Math.max(1, ...rows.map(r => r.contacts));

  return (
    <div className="bg-white border border-stone-200 p-6" data-testid="district-heatmap">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-ccc-gold-dark inline-flex items-center gap-1 mb-1">
            <MapPin size={11}/> District engagement
          </div>
          <h2 className="font-serif text-xl text-ccc-plum leading-tight">Where the network has weight.</h2>
        </div>
        <div className="flex text-xs uppercase tracking-wider border border-stone-300">
          {["House", "Senate"].map(c => (
            <button
              key={c}
              onClick={() => setChamber(c)}
              data-testid={`heatmap-toggle-${c.toLowerCase()}`}
              className={`px-3 py-1 ${chamber === c ? "bg-ccc-plum text-white" : "bg-white text-ccc-plum"}`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="text-sm text-stone-500 py-6 text-center">
          District data will appear here once advocates submit their address on Take Action forms.
        </div>
      ) : (
        <div className="space-y-2">
          {rows.map(r => (
            <div key={r.district} className="flex items-center gap-3 text-sm" data-testid={`heatmap-row-${r.district}`}>
              <span className="w-16 shrink-0 font-mono text-xs text-ccc-plum">{r.district}</span>
              <div className="flex-1 h-5 bg-stone-100 relative overflow-hidden">
                <div
                  className="h-full bg-ccc-purple"
                  style={{ width: `${(r.contacts / max) * 100}%` }}
                />
                <div className="absolute inset-y-0 right-2 flex items-center text-[11px] text-stone-600">
                  {r.contacts}
                </div>
              </div>
              <span className="w-14 shrink-0 text-right text-xs text-stone-500">
                {r.avg_engagement ? `${r.avg_engagement} avg` : "—"}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
